"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgClockOutline = function SvgClockOutline(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    id: 'clock-outline_svg__a',
    d: 'M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zM11 7.5c0-.667.333-1 1-1s1 .333 1 1v4.155l2.01 1.996c.435.426.429.872-.02 1.336-.447.465-.922.471-1.426.02l-1.962-1.919c-.246-.26-.407-.48-.483-.663-.077-.182-.117-.437-.119-.767V7.5z'
  })), react_1.default.createElement("use", {
    xlinkHref: '#clock-outline_svg__a'
  }));
};

exports.default = SvgClockOutline;